/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb, Form, Input, Button, Select, InputNumber,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';
// import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';

import useCreateInverters from './useCreateInverters';
import styles from './CreateInverters.module.less';

function CreateInverters() {

  const { t } = useTranslation();
  const {
    onFinishFailed,
    onFinish,
    formOnValuesChange,
    deviceId,
    dataModelInverters,
    dataForm,
    idToEdit,
    cancelCreateEditDevice,
    goToCreateDevice,
    goToCreateInverterModel,
  } = useCreateInverters();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>
            <Link to="/tablero-general">{t('menu_items.main.general_board')}</Link>
          </Breadcrumb.Item>
          {(idToEdit)
            ? (
              <>
                <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.devices_edit')}</Breadcrumb.Item>
                <Breadcrumb.Item className={styles.breadcrumb}>{idToEdit}</Breadcrumb.Item>
              </>
            )
            : <Breadcrumb.Item className={styles.breadcrumb}>{t('views.create_devices.new_inverter')}</Breadcrumb.Item>}
        </Breadcrumb>
        <Form
          name="CreateInverters"
            // labelCol={{ span: 10 }}
            // wrapperCol={{ span: 22 }}
          layout="vertical"
          initialValues={{
            ...dataForm, remenber: true,
            // remember: true, name: 'jhon', client: 'example', state: 'normal',
          }}
          values={{ name: 'jhon', client: 'example', state: 'normal' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >
          <div className={styles.containerForm}>
            <div className={styles.cancelBtn}>
              <Button onClick={cancelCreateEditDevice}>X</Button>
            </div>
            <div className={styles.column}>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.code')}
                name="code"
                rules={[
                  { required: true, message: t('form.form_create_inverter.code_message') },
                  { type: 'string', max: 20, message: t('form.form_create_inverter.code_max') },
                ]}
              >
                <Input className={styles.input} placeholder={t('form.form_create_inverter.code_placeholder')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('views.create_devices.form.client')}
                name="client"
                rules={[{ required: true, message: t('views.create_devices.form.client_message') }]}
              >
                <Input className={styles.input} placeholder={t('views.create_devices.form.client_place_holder')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.solar_capacity')}
                name="solar_capacity"
                rules={[
                  { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.storage_capacity')}
                name="storage_capacity"
                rules={[
                  { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.inverter_capacity')}
                name="inverter_capacity"
                rules={[
                  { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.solar_panel_number')}
                name="solar_panel_number"
                rules={[
                  { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.battery_cycles')}
                name="battery_cycles"
                rules={[
                  { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.battery_voltage')}
                name="battery_voltage"
                rules={[
                  { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" min="0" step="0.01" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

            </div>

            <div className={styles.column}>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.battery_type')}
                name="battery_type"
                rules={[{ required: true, message: t('form.form_create_inverter.solar_capacity_message') }]}
              >
                <Select className={styles.select}>
                  <Select.Option value="Litio">Litio</Select.Option>
                  <Select.Option value="Niquel">Niquel</Select.Option>
                  {/* <Select.Option value="Plomo acido">Plomo ácido</Select.Option> */}
                </Select>
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.location')}
                name="location"
                rules={[
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                  { type: 'string', max: 16, message: t('views.create_devices.form.mac_message_max') },
                ]}
              >
                <Input className={styles.input} placeholder={t('form.form_create_inverter.location_placeholder')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.address')}
                name="address"
                rules={[
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                  // { type: 'string', max: 16, message: t('views.create_devices.form.mac_message_max') },
                ]}
              >
                <Input className={styles.input} placeholder={t('form.form_create_inverter.address_placeholder')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.latitude')}
                name="latitude"
                rules={[
                  // { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" step="0.1" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('form.form_create_inverter.longitude')}
                name="longitude"
                rules={[
                  // { type: 'number' },
                  { required: true, message: t('form.form_create_inverter.solar_capacity_message') },
                ]}
              >
                <InputNumber type="number" step="0.1" className={styles.input_number} placeholder={t('views.createModelInverter.form.inverterCharacteristics')} />
              </Form.Item>

              <div className={styles.btn_and_select}>
                <Form.Item
                  className={styles.label}
                  label={t('form.form_create_inverter.device_id')}
                  name="device_id"
                  rules={[{ required: true, message: t('form.form_create_inverter.solar_capacity_message') }]}
                >
                  <Select onChange={(e) => formOnValuesChange({ device_id: e })} className={styles.select} value={dataForm.device_id}>
                    {deviceId.map((device) => (
                      <Select.Option key={device.id} value={device.id}>{device.mac}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Button
                  className={styles.btn_select}
                  type="primary"
                  onClick={goToCreateDevice}
                >
                  {t('views.create_devices.new_device')}
                </Button>
              </div>
              <div className={styles.btn_and_select}>
                <Form.Item
                  className={styles.label}
                  label={t('form.form_create_inverter.inverter_model_id')}
                  name="inverter_model_id"
                  rules={[{ required: true, message: t('form.form_create_inverter.solar_capacity_message') }]}
                >
                  <Select className={styles.select} onChange={(e) => formOnValuesChange({ inverter_model_id: e })} value={dataForm.inverter_model_id}>
                    {dataModelInverters.map((modelInverter) => (
                      <Select.Option key={modelInverter.id} value={modelInverter.id}>{modelInverter.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Button
                  className={styles.btn_select}
                  type="primary"
                  onClick={goToCreateInverterModel}
                >
                  {t('views.createModelInverters.newModelInverter')}
                </Button>
              </div>
            </div>
          </div>
          <Form.Item wrapperCol={{ offset: 0 }} className={styles.containerBtn}>
            <Button className={styles.btn} type="primary" htmlType="submit" icon={<SaveOutlined />}>
              {t('views.create_devices.form.button')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </MainLayout>
  );

}

export default withAuth(CreateInverters);
